import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

export const triggerWrap: SxProps<Theme> = {
  position: "relative",
};

export const trigger: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  gap: { xs: 0.375, sm: 0.5, md: 0.75, lg: 1 },
  py: { xs: 0.375, sm: 0.5, md: 0.625, lg: 0.75 },
  ps: { xs: 0.375, sm: 0.5, md: 0.75, lg: 1 },
  pe: { xs: 0.5, sm: 0.5, md: 0.875, lg: 1.25 },
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: { xs: 1.25, md: 1.5 },
  bgcolor: "background.paper",
  cursor: "pointer",
  fontFamily: theme.typography.fontFamily,
  minWidth: 0,
  flexShrink: 1,
  maxWidth: { xs: 140, sm: 160, md: 190, lg: 240 },
});

export const storeIcon: SxProps<Theme> = (theme) => ({
  width: { xs: 28, sm: 26, md: 28, lg: 30 },
  height: { xs: 28, sm: 26, md: 28, lg: 30 },
  borderRadius: 1.125,
  bgcolor: alpha(theme.palette.primary.main, 0.1),
  color: "primary.main",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

export const storeText: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  lineHeight: 1.25,
  minWidth: 0,
  overflow: "hidden",
};

export const storeName: SxProps<Theme> = {
  fontSize: { xs: "0.6875rem", sm: "0.6875rem", md: "0.75rem", lg: "0.78125rem" },
  fontWeight: 700,
  maxWidth: { xs: 84, sm: 104, md: 128, lg: 170 },
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const storeRole: SxProps<Theme> = {
  display: { xs: "none", sm: "none", lg: "inline" },
  fontSize: "0.625rem",
  color: "text.secondary",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: { lg: 170 },
};

export const storeChevron: SxProps<Theme> = {
  display: "flex",
  flexShrink: 0,
};

export const paper: SxProps<Theme> = (theme) => ({
  mt: 1,
  width: 260,
  borderRadius: 2,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.shadows[4],
  p: 1,
});

export const menuLabel: SxProps<Theme> = {
  px: 1.25,
  py: 0.75,
  fontSize: "0.71875rem",
  color: "text.secondary",
  fontWeight: 600,
};

export const shopRow =
  (active: boolean): SxProps<Theme> =>
  (theme) => ({
    display: "flex",
    alignItems: "center",
    gap: 1.25,
    px: 1.25,
    py: 1.125,
    borderRadius: 1.375,
    cursor: "pointer",
    bgcolor: active ? alpha(theme.palette.primary.main, 0.08) : "transparent",
    "&:hover": {
      bgcolor: alpha(theme.palette.primary.main, 0.06),
    },
  });

export const createLink: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1.25,
  px: 1.25,
  py: 1.125,
  borderRadius: 1.375,
  textDecoration: "none",
  color: "primary.main",
  fontSize: "0.8125rem",
  fontWeight: 700,
};

export const divider: SxProps<Theme> = {
  my: 0.75,
  mx: 0.5,
};
